import PropTypes from 'prop-types';

import { CUSTOMIZATION_ORIENTATIONS, CUSTOMIZATION_SIZES, CUSTOMIZATION_POSITIONS } from '../customization';

export const CustomizationPropTypes = {
  text: PropTypes.string,
  orientation: PropTypes.oneOf(Object.values(CUSTOMIZATION_ORIENTATIONS)),
  size: PropTypes.oneOf(Object.values(CUSTOMIZATION_SIZES)),
  signature: PropTypes.string,
  position: PropTypes.oneOf(Object.values(CUSTOMIZATION_POSITIONS))
};
